/*
# Notes textarea subview
*/

var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['backbone', 'template/document-entry/notes.htm'], function(Backbone, notesTemplate) {
  var NotesView;
  return NotesView = (function(_super) {

    __extends(NotesView, _super);

    function NotesView() {
      NotesView.__super__.constructor.apply(this, arguments);
    }

    NotesView.prototype.className = 'document-notes-wrapper';

    NotesView.prototype.template = notesTemplate;

    NotesView.prototype.events = {
      'change #document-notes': 'saveNotes'
    };

    NotesView.prototype.initialize = function() {
      this.model.on('change:documentType', this.updateType, this);
      return this.render();
    };

    NotesView.prototype.render = function() {
      return this.$el.html(_.template(this.template, this.model.toJSON()));
    };

    /*
    # @param {String} size can take 'large' and 'normal' values
    */


    NotesView.prototype.updateSize = function(size) {
      if (size === 'large') {
        return this.$el.addClass('large');
      } else {
        return this.$el.removeClass('large');
      }
    };

    NotesView.prototype.updateType = function() {
      switch (this.model.get('documentType')) {
        case 'RECEIPT':
        case 'TRANSACTIONAL':
          return this.updateSize('normal');
        default:
          return this.updateSize('large');
      }
    };

    NotesView.prototype.saveNotes = function(e) {
      return this.model.set('notes', $(e.currentTarget).val());
    };

    return NotesView;

  })(Backbone.View);
});
